export default __webpack_public_path__ + "static/media/date_range.6557e1ed.svg";